import {motion} from "framer-motion";
import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';

const spring = {
    type: "spring",
    damping: 20,
    stiffness: 300,
};

const Numbers2 = ({onSelect, numbers2, randomNumber, isEnabled}) => {
    // console.log("tired", numbers2);
    // console.log("promise", numbers2.nList);

    const [boardSize, setBoardSize] = useState({width: 0, height: 0});
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            if (containerRef.current) {
                const width = containerRef.current.getBoundingClientRect().width;
                setContainerWidth(width);
                const boardContainerWidth = width;
                setBoardSize({width: boardContainerWidth});
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Container id="board-container" ref={containerRef}  >
            {numbers2.visibility.map((vis, index) => (
                isEnabled ? (
                    <Circle
                        key={index}
                        layout
                        transition={spring}
                        // style={{backgroundColor: "#15aeb8"}}
                        onClick={() => onSelect(index, randomNumber)}
                        side={Math.floor(boardSize.width / 10)}
                        vix={vis}
                    >
                        <CircleText>{index + 1}</CircleText>

                    </Circle>
                ) : (
                    <Circle
                        key={index}
                        layout
                        transition={spring}
                        style={{
                            backgroundColor: "#808080"
                        }}
                        side={Math.floor(boardSize.width / 10)}
                        vix={vis}
                    >
                        <CircleText>{index + 1}</CircleText>

                    </Circle>
                )

            ))}
        </Container>
    );
};

export default Numbers2;

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 1px;
  width: 40%;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
  }

//   display: grid;
//     grid-template-columns: repeat(14, 15px);
//     width: 100%;
//     display: flex;
//     flex-wrap: wrap;
//     align-content: flex-end;
//     grid-gap: 0.2rem;
//     justify-content: end;
//     @media screen and (max-device-width: 480px) and (orientation: portrait) {
//       display: flex;
//       grid-gap: 0.1rem;
//   }
`;

const Circle = styled(motion.li)`
  width: ${props => props.side}px;
  height: ${props => props.side}px;
  visibility: ${props => props.vix};
  border-radius: 20%;
  margin: 5px;
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
background-color: ${({theme}) => theme.colors.buttons1};


//   background-color: #ef7e32;
//   border: 1px solid #79aea3;
  margin: 5px;
  font-size: 24px;
  font-weight: bold;
    color: ${({theme}) => theme.colors.textColor2};

`;

const CircleText = styled.p`
  font-size: 1.2rem;
  font-family: text7;
  font-weight: bold;
`;